// Display labels only; saved grading flags and category names remain unchanged.
const LABELS={'Straight':'STRAIGHT HIT!','Box':'BOX HIT!','Fireball Straight':'FIREBALL HIT! (Straight)','Fireball Box':'FIREBALL HIT! (Box)'};
function hitLabels(types){return types.map(t=>LABELS[t]).filter(Boolean);}
module.exports={hitLabels};
